import * as types from './types';
import * as actionTypes from './constants';
import { IAction } from '@state/types';

const defaultState: types.IDesignsState = { };

const designTypeReducer = (
  state: types.IDesignsState = defaultState, 
  action: IAction | types.ISetDesignAction
) => {
  switch ((action as IAction).type) {
    case actionTypes.SET_DESIGN: {
      return {...state, designs: (action as types.ISetDesignsAction).designs};
    }
    case actionTypes.SET_DESIGN_INFO: {
      return {...state, design: (action as types.ISetDesignAction).design};
    }
    case actionTypes.SET_DESIGN_AUTH: {
      return {...state, designAuth: (action as types.IDesignAuthSuccessAction).designAuth, designAuthMailErrors: (action as types.IDesignAuthSuccessAction).designAuthMailErrors};
    }
    case actionTypes.ADD_SUCCESS_DESIGN: {
      return {...state, designResponse: (action as types.IServerSuccessAction).designResponse};
    }
    case actionTypes.SET_SEARCH_DESIGN: {
      return {...state, designSearches: (action as types.ISetSearchAction).designSearches};
    }
    case actionTypes.SET_DESIGN_COUNTERS: {
      return {...state, counter: (action as types.ISetDesignCountersAction).counter};
    }
    case actionTypes.SET_COUNTER_DESIGNS: {
      return {...state, counterDesigns: (action as types.ISetCounterAction).counterDesigns};
    }
    case actionTypes.ADD_SUCCESS_FAVORITE: {
      return {...state, designFavoriteResponse: (action as types.IDesignFavoriteSuccessAction).designFavoriteResponse};
    }
    case actionTypes.SET_COUNTER_SHARED_FILES: {
      return {...state, counterSharedFiles: (action as types.ISetCounterSharedFilesAction).counterSharedFiles};
    }
    
    default: {
      return state;
    }
  }
};


export default designTypeReducer;
